import script from "./BaseSddsDropdownFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSddsDropdownFilter.vue?vue&type=script&setup=true&lang=js"

import "./BaseSddsDropdownFilter.vue?vue&type=style&index=0&id=25ea882f&scoped=true&lang=css"

import exportComponent from "/builds/izee/leadservice/lead-admin-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ea882f"]])

export default __exports__